import { render } from "./PdfExtractionSaveModal.vue?vue&type=template&id=41a76404&scoped=true"
import script from "./PdfExtractionSaveModal.vue?vue&type=script&lang=js"
export * from "./PdfExtractionSaveModal.vue?vue&type=script&lang=js"

import "./PdfExtractionSaveModal.vue?vue&type=style&index=0&id=41a76404&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41a76404"]])

export default __exports__